<template>
  <router-view />
</template>

<script>
export default {
  name: "AuthXBase"
};
</script>

<style></style>
